import { SitecoreContextValue } from '@sitecore-jss/sitecore-jss-react/types/components/SitecoreContext';

// Recommended, SSG/ISR-compatible method for component-level checks (works for everything under Layout)
export const isBlueparrottFromContext = (sitecoreContext: SitecoreContextValue) =>
  sitecoreContext?.site?.name?.includes('blueparrott') ?? false;
